module.exports = __webpack_public_path__ + "img/2206.8e4d77dd.jpg";